import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Location } from "../location";
import {
  Http,
  Response,
  Headers,
  URLSearchParams,
  RequestOptions
} from "@angular/http";
import { Observable } from "rxjs";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { RechercheOffresCommercialesForm } from "./model/form/rechercheOffresCommercialesForm";
import { TypeTransport } from "./model/typeTransport";
import { Manutentionnaire } from "./model/manutentionnaire";
import { OffreLightByTypeTouche } from "./model/offreLightByTypeTouche";
import { OffreCommerciale } from "./model/offreCommerciale";
import { DetailOffreCommercialForm } from "./model/form/detailOffreCommercialForm";
import { UserInformaions } from "../common/userinformations";
import { AbstractLrmService } from "../common/abstractlrmService";

@Injectable()
export class OffrecommercialeService extends AbstractLrmService {
  //Create constructor to get Http instance
  constructor(http: Http) {
    super(http);
  }

  sendUserInformationsAtConnection(
    userInformations: UserInformaions
  ): Observable<void> {
    let endPoint: string = "/sessionInfos";
    return this.postRequestVoid(endPoint, userInformations);
  }

  getOffrescommercialesByForm(
    form: RechercheOffresCommercialesForm
  ): Observable<OffreLightByTypeTouche> {
     
    let endPoint: string = "/offresCommercialesByForm";
    return this.postRequest(endPoint, form);
  }

  getDetailOffrecommerciale(
    form: DetailOffreCommercialForm
  ): Observable<OffreCommerciale> {
    let endPoint: string = "/detailOffreCommerciale";
    return this.postRequest(endPoint, form);
  }

  getOffrescommercialesToGeoServer(
    idPortVers: number,
    codeLangue: string
  ): Observable<OffreLightByTypeTouche> {
    let form: RechercheOffresCommercialesForm = new RechercheOffresCommercialesForm(
      codeLangue,
      null,
      idPortVers,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      false
    );
    let endPoint: string = "/offresCommercialesByForm";
    return this.postRequest(endPoint, form);
  }

  //Fetch all offrecomerciales
  getAllTypesTransports(lang: string): Observable<TypeTransport[]> {
    let endPoint: string = "/typesTransports?lang=" + lang;
    return this.getRequest(endPoint);
  }

  //Fetch all Compagnies maritimes
  getAllCompagniesMaritimes(): Observable<TypeTransport[]> {
    let endPoint: string = "/compagniesMaritimes";
    return this.getRequest(endPoint);
  }

  //Fetch all manutentionnaires
  getAllManutentionnaires(): Observable<Manutentionnaire[]> {
    let endPoint: string = "/manutentionnaires";
    return this.getRequest(endPoint);
  }

  getAlljson(): Observable<any[]> {
    alert(
      this.http
        .get("assets/airports.min.geojson")
        .map(this.extractData)
        .catch(this.handleError)
    );

    return this.http
      .get("assets/airports.min.geojson")
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/offrecommerciale/offrecommerciale.service.ts